/*global localforage  */
let _ = require("ES/lib/lodash");
let dd = require("ES/lib/dd");
let esUtils = require("ES/utils/esUtils");
let radio = require("ES/lib/react-pubsub-via-radio.js/radio");
let FormMixin = require("react-loose-forms");
let ErrorAlert = require("ES/widgets/ErrorAlert");
let LoadingWrap = require("ES/widgets/LoadingWrap");
let FormButtons = require("react-loose-forms.bootstrap3/layouts/FormButtons");
let ConfirmModal = require("../../widgets/ConfirmModal");
let FormUtils = require("../../../utils/FormUtils");
let SlideOpenDown = require("../../widgets/SlideOpenDown");
let RadioServiceMixin = require("ES/lib/react-pubsub-via-radio.js/RadioServiceMixin");
let ActionListItemEditor = require("./ActionListItemEditor");
let DisplaylistSpeaker_to_actionlistSaveData = require("./DisplaylistSpeaker_to_actionlistSaveData");

let DRAG_THRESHOLD = 3;

let ListItem = dd.createClass({
  getInitialState: function () {
    return {
      mouseDown: false,
      dragging: false,
      left: 0,
      right: 0,
      originX: 0,
      originY: 0,
      elementX: 0,
      elementY: 0
    };
  },
  onMouseDown: function (event) {
    let pageOffset;
    if (event.button === 0 && this.refs && this.refs.main) {//left button
      event.stopPropagation();
      this.addEvents();
      pageOffset = this.refs.main.getBoundingClientRect();
      this.setState({
        mouseDown: true,
        originX: event.pageX,
        originY: event.pageY,
        elementX: pageOffset.left,
        elementY: pageOffset.top - 52//TODO better get this offset
      });
    }
  },
  onMouseMove: function (event) {
    let deltaX, deltaY, distance;
    deltaX = event.pageX - this.state.originX;
    deltaY = event.pageY - this.state.originY;
    distance = Math.abs(deltaX) + Math.abs(deltaY);
    if (!this.state.dragging && distance > DRAG_THRESHOLD) {
      this.setState({
        dragging: true
      });
      this.onDragStart();
    }
    if (this.state.dragging) {
      this.setState({
        left: this.state.elementX + deltaX + document.body.scrollLeft,
        top: this.state.elementY + deltaY + document.body.scrollTop
      });
    }
  },
  onMouseUp: function () {
    this.removeEvents();
    if (this.state.dragging) {
      this.onDragStop();
      this.setState({
        dragging: false
      });
    }
  },
  addEvents: function () {
    document.addEventListener("mousemove", this.onMouseMove);
    document.addEventListener("mouseup", this.onMouseUp);
  },
  removeEvents: function () {
    document.removeEventListener("mousemove", this.onMouseMove);
    document.removeEventListener("mouseup", this.onMouseUp);
  },
  __onDeleteClicked: esUtils.wrapPreventDefault(function () {
    this.props.deleteItem(this.props.item);
  }),
  __onClick: esUtils.wrapPreventDefault(function () {
    this.props.setEditingItem(this.props.item);
  }),
  onDragStart: function () {
    this.props.onItemDragStart(this.props.item);
  },
  onDragStop: function () {
    this.props.onItemDragStop(this.props.item);
  },
  onMouseEnter: function () {
    this.props.setItemIDHoveredOver(this.props.item.id);
  },
  onMouseLeave: function () {
    this.props.setItemIDHoveredOver(null);//no longer being hovered over
  },
  render: function () {
    let item = this.props.item;
    let is_drag_over_me = this.props.is_drag_over_me;

    return dd.tbody({
        onMouseEnter: this.onMouseEnter,
        onMouseLeave: this.onMouseLeave
      },
      is_drag_over_me ? dd.tr(null, dd.td({colSpan: 3}, dd.br())) : null,
      dd.tr({
          ref: "main",
          style: this.state.dragging ? {
            position: "absolute",
            left: this.state.left,
            top: this.state.top
          } : {},
          className: "MasterListItem " + (this.state.dragging ? "dragging" : "")
        },
        dd.td({className: "text-muted draggable", onMouseDown: this.onMouseDown},
          dd.i({className: "fa fa-bars"})
        ),
        dd.td({className: "clickable", onClick: this.__onClick},
          item.description
        ),
        dd.td(null, dd.a({href: "#", onClick: this.__onDeleteClicked},
          dd.i({className: "fa fa-times"}))
        )
      )
    );
  }
});

let DaForm = dd.createClass({
  mixins: [FormMixin],
  getInitialState: function () {
    return {
      item_dragging: null,
      item_id_being_hovered: null
    };
  },
  getInitialValues: function (props) {
    let list = props.list;
    return {
      name: list.listname,
      item_ids_in_order: _.map(_.sortBy(_.map(list.masters, function (item, id) {
        return _.assign({}, item, {id: id});
      }), "vieworder"), "id")
    };
  },
  buildSchema: function () {
    return {
      name: {
        label: "List Name",
        type: "text",
        validate: FormUtils.v.required
      }
    };
  },
  __deleteList: esUtils.wrapPreventDefault(function () {
    this.props.deleteList();
  }),
  __newItem: esUtils.wrapPreventDefault(function () {
    this.props.setEditingItem({id: -1});
  }),
  __discardChanges: esUtils.wrapPreventDefault(function () {
    this.Form_reset();//react-loose-forms
  }),
  __deleteItem: function (item) {
    //remove the item from the list
    this.Form_onChange("item_ids_in_order", _.filter(this.state.data.item_ids_in_order, function (id) {
      return id !== item.id;
    }));
  },
  __setItemIDHoveredOver: function (item_id) {
    if (!this.state.item_dragging) {
      //not dragging anything
      if (item_id === null && this.state.item_id_being_hovered !== item_id) {
        //reset to null
        this.setState({item_id_being_hovered: null});
      }
      return;
    }
    this.setState({item_id_being_hovered: item_id});
  },
  __onItemDragStart: function (item) {
    this.setState({item_dragging: item});
  },
  __onItemDragStop: function (item) {
    let h_id = this.state.item_id_being_hovered;
    let old_order = this.state.data.item_ids_in_order;

    let injected_new = false;
    let new_order = [];
    _.each(old_order, function (id) {
      if (item.id === id) {
        //we're going to put it somewhere new
        return;
      }
      if (h_id === id) {
        new_order.push(item.id);
        injected_new = true;
      }
      new_order.push(id);
    });
    if (!injected_new) {
      new_order.push(item.id);
    }
    this.Form_onChange("item_ids_in_order", new_order);
    this.setState({item_dragging: null, item_id_being_hovered: null});
  },
  render: function () {
    let data = this.state.data || {};
    let fields = this.Form_buildSchema();
    let errors = this.state.errors || {};
    let buildInput = this.Form_buildInput;
    let changes_made = this.Form_areChangesMade();

    let list = this.props.list;
    let setEditingItem = this.props.setEditingItem;

    let list_name;
    if (list.id === 0) {
      list_name = dd.h4(null, data.name);
    } else {
      list_name = dd.div({},
        dd.button({
          className: "btn btn-danger btn-sm pull-right",
          onClick: this.__deleteList
        }, "Delete"),
        dd.div({className: errors.name ? "has-error" : null, style: {maxWidth: "70%"}},
          buildInput(fields.name),
          errors.name ? dd.span({className: "help-block"}, errors.name) : null
        )
      );
    }

    let items = _.map(_.map(data.item_ids_in_order, function (id) {
      return _.assign({}, list.masters[id], {id: id});
    }), _.bind(function (item) {
      return ListItem({
        key: item.id,
        item: item,
        deleteItem: this.__deleteItem,
        setEditingItem: setEditingItem,
        is_drag_over_me: this.state.item_id_being_hovered === item.id,
        setItemIDHoveredOver: this.__setItemIDHoveredOver,
        onItemDragStart: this.__onItemDragStart,
        onItemDragStop: this.__onItemDragStop
      });
    }, this));

    return dd.form({onSubmit: this.Form_onSubmit},
      list_name,
      dd.table({className: "table table-condensed table-hover"},
        dd.thead(null,
          dd.tr(null,
            dd.th({style: {width: 1}}),
            dd.th(null, "Action Items"),
            dd.th({style: {width: 1}})
          )
        ),
        items
      ),
      _.isEmpty(items) ? dd.div({className: "text-center"},
        dd.h3({className: "text-muted"}, "-- empty list --"),
        dd.button({className: "btn btn-default", onClick: this.__newItem}, "Create Item")
      ) : dd.div({style: {marginBottom: 15, float: "right"}},
        dd.button({className: "btn btn-default btn-sm", onClick: this.__newItem}, "New Item")
      ),
      SlideOpenDown({open: changes_made},
        FormButtons({onDiscard: this.__discardChanges})
      )
    );
  }
});

module.exports = dd.createClass({
  mixins: [RadioServiceMixin],
  RadioService_setup() {
    return {
      Actionlists_save: {
        key() {
          return 1;
        }
      }
    };
  },
  getInitialState: function () {
    return {editing_item: null, show_delete_list_confirm: false};
  },
  __onSubmit: function (data) {
    let speaker = this.props.speaker;
    let list_id = this.props.list_id;

    let to_save = {};
    to_save[speaker.sid] = DisplaylistSpeaker_to_actionlistSaveData(speaker);

    to_save[speaker.sid][list_id].name = data.name;

    var old_items = to_save[speaker.sid][list_id].items;
    var new_items = {};//only add ones that are in item_ids_in_order

    //set vieworder based on position
    _.map(data.item_ids_in_order, function (id, i) {
      new_items[id] = old_items[id];
      new_items[id].vieworder = i;
    });
    to_save[speaker.sid][list_id].items = new_items;

    radio("Actionlists_save").broadcast(to_save);
  },
  __setEditingItem: function (item) {
    this.setState({editing_item: item});
  },
  __closeEditingItem: esUtils.wrapPreventDefault(function () {
    this.setState({editing_item: null});
  }),
  __toggleDeleteConfirm: esUtils.wrapPreventDefault(function () {
    this.setState({show_delete_list_confirm: !this.state.show_delete_list_confirm});
  }),
  __deleteList: esUtils.wrapPreventDefault(function () {
    let speaker = this.props.speaker;
    let list_id = this.props.list_id;

    let to_save = {};
    to_save[speaker.sid] = DisplaylistSpeaker_to_actionlistSaveData(speaker);
    delete to_save[speaker.sid][list_id];

    radio("Actionlists_save").broadcast(to_save);

    this.setState({show_delete_list_confirm: false});
  }),
  render: function () {
    let list_id = this.props.list_id;
    let speaker = this.props.speaker;
    let ajax = this.state.Actionlists_save;

    let editing_item = this.state.editing_item;

    let list = _.find(speaker.todolists, function (list) {
      return list.id === list_id;
    });

    if (!list) {
      //may have tried to restore another speaker's list, so let's default to 0
      list_id = 0;
      localforage.setItem('actionlist_edit_id', 0); //reset to 'standard'
      list = _.find(speaker.todolists, {'id':0});
    }
    if (!list) {
      //still can't find the list
      return ErrorAlert({message: "List not found."});
    }

    return dd.div({className: "EditMasterList"},
      ErrorAlert({message: ajax.error}),
      LoadingWrap({is_loading: ajax.waiting, text: "Saving..."},
        DaForm({
          list: list,
          speaker: speaker,
          onSubmit: this.__onSubmit,
          deleteList: this.__toggleDeleteConfirm,
          setEditingItem: this.__setEditingItem
        })
      ),
      editing_item
        ? ActionListItemEditor({
          item: editing_item,
          list_id: list_id,
          speaker: speaker,
          onClose: this.__closeEditingItem
        })
        : null,
      this.state.show_delete_list_confirm
        ? ConfirmModal({
          message: "Are you sure you want to delete this list?",
          onYes: this.__deleteList,
          onClose: this.__toggleDeleteConfirm
        })
        : null
    );
  }
});



// WEBPACK FOOTER //
// ./src/components/account_settings/action_lists/EditMasterList.js